import { graphql } from 'graphql-schema';

const CHECK_CAN_SEND_RSVP_REMINDER = graphql(`
  query CheckCanSendRSVPReminder($gameId: uuid!, $teamId: uuid!, $userId: uuid) {
    checkCanSendRsvpReminder(game: $gameId, team: $teamId, user: $userId) {
      reminder_eligible
    }
  }
`);

export default CHECK_CAN_SEND_RSVP_REMINDER;
